import { PaymentModel } from "../../data/entities/invoices/PaymentModel";
import { InvoiceModel } from "../../data/entities/invoices/InvoiceModel";
import { PaymentODataRepo, PaymentRepo } from "../../data/repo";
import { PaymentRequestDTO, PaymentResponseDTO } from "../../models";
import { BaseEntityService } from "../BaseEntityService";
import { CapturePreAuthRequestDTO, RefundRequestDTO, VoidPreAuthRequestDTO } from "../../data/entities/payment";


export class PaymentService extends BaseEntityService<PaymentModel, PaymentRepo, PaymentODataRepo>{
    constructor(){
        super(new PaymentRepo(), new PaymentODataRepo())
    }

    async processPaymentAsync(paymentRequest: PaymentRequestDTO): Promise<PaymentResponseDTO> {
        return await this.repo.processPaymentAsync(paymentRequest);
    }

    async createStripeClientSecretAsync(invoice: InvoiceModel): Promise<string> {
        return await this.repo.createStripeClientSecretAsync(invoice);
    }

    async capturePreAuthAsync(request: CapturePreAuthRequestDTO): Promise<boolean> {
        return await this.repo.capturePreAuthAsync(request);
    }

    async voidPreAuthAsync(request: VoidPreAuthRequestDTO): Promise<boolean> {
        return await this.repo.voidPreAuthAsync(request);
    }

    async refundChargeAsync(request: RefundRequestDTO): Promise<boolean> {
        return await this.repo.refundChargeAsync(request);
    }
}
